// extracted by mini-css-extract-plugin
module.exports = {"lawyerPicture":"watchers_utils-module__lawyerPicture--lUiyP"};